export const state = {
  currentEnv: process.env.NODE_ENV,
  forcedMenuHidden: false
}

export const getters = {
  isProductionEnv: state => ['production', 'prod'].includes(state.currentEnv),
  isForcedMenuHidden: state => state.forcedMenuHidden
}

export const actions = {
  SET_HIDDEN_MENU_FORCED: ({ state }, payload) => {
    state.forcedMenuHidden = payload
  }
}

export default {
  getters,
  state,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general.module.js